import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Typography,
  Card,
  CardContent
} from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'
import { GmailConnectButton } from '../../../../../components/preview/Preview'
import { EMAIL_ACCOUNT_TYPES } from '../../../utils/campaignConstants'

const GmailConfigurationSection = ({ languageGSD, userEditState }) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ mt: 3 }}>
      <Card variant="outlined" sx={{
        backgroundColor: '#ffffff',
        border: '1px solid #e0e0e0',
        borderRadius: 3,
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
      }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ mb: 8, textAlign: 'center' }}>
            <EmailIcon sx={{
              fontSize: 48,
              color: 'primary.main',
              mb: 2,
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
            }}/>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
              {t('mailTemplate.users.modal.gmailIntegration')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 400, mx: 'auto' }}>
              {t('mailTemplate.users.modal.gmailIntegrationDescription')}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <GmailConnectButton
              langCode={languageGSD}
              email={userEditState?.emailSettings?.emailUserName}
              connected={userEditState?.emailSettings?.accountType === EMAIL_ACCOUNT_TYPES.GMAIL_OAUTH2}
              onDisconnect={() => {
                // TODO: Implement disconnect functionality
              }}
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default GmailConfigurationSection
